import { jsxs, jsx } from "react/jsx-runtime";
const IconMoneySvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "none",
          d: "M19 7H5a2 2 0 0 1-2 2v6a2 2 0 0 1 2 2h14a2 2 0 0 1 2-2V9a2 2 0 0 1-2-2Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M22.945 7.45a3 3 0 0 0-2.396-2.395A2.988 2.988 0 0 0 20 5H4c-.188 0-.37.022-.55.055a3 3 0 0 0-2.395 2.396A2.988 2.988 0 0 0 1 8v8c0 .188.022.37.055.55a3 3 0 0 0 2.396 2.395c.178.033.361.055.549.055h16c.188 0 .37-.022.55-.055a3 3 0 0 0 2.395-2.396c.033-.178.055-.36.055-.549V8c0-.188-.022-.37-.055-.55ZM21 15a2 2 0 0 0-2 2H5a2 2 0 0 0-2-2V9a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v6Z" }),
      /* @__PURE__ */ jsx("path", { d: "M12 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4Zm0-6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2Z" })
    ]
  }
);
export {
  IconMoneySvg
};
